module.exports = __webpack_public_path__ + "img/Banner100kata2021-min-2.2ac4e54b.jpg";